import { api } from '@api'
import { userId } from '@state/auth'
import type { PostForm } from './postSchema'

export const savePost = async (values: PostForm) => {
	const { data, error } = await api()
		.from('go_read_posts')
		.insert({ ...values, profile_id: userId() as string })
		.select()
		.single()

	if (error) throw new Error(error.message)
	return data
}

export const updatePost = async ({
	id,
	values,
}: { id: string; values: PostForm }) => {
	const { data, error } = await api()
		.from('go_read_posts')
		.update(values)
		.eq('id', id)
		.select()
		.single()

	if (error) throw new Error(error.message)
	return data
}
